<template>
  <div class="col-md-8 col-sm-12 offset-lg-2 offset-sm-0 grid-margin stretch-card">
    <div class="card">
      <div class="card-body">
        <div class="row mb-4">
          <div class="col-md-6">
            <h3 class="font-weight-bold">
              {{ solicitudEdicionSeleccionada ? 'Revisar la solicitud' : '' }}
            </h3>
          </div>
          <div class="col-md-6"></div>
        </div>
        <div class="white-content-general mb-4">
          <div class="row">
            <div class="card">
              <div class="card-body">
                <div class="row mb-4">
                  <div class="col-md-12">
                    <h5>Datos antiguos</h5>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-md-6">
                    <table class="table table-stripped">
                      <thead>
                        <tr>
                          <th>Nombre</th>
                          <th>Email</th>
                          <th>Rol</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {{
                              solicitudEdicionSeleccionada
                                ? solicitudEdicionSeleccionada.oldData.nombre
                                : ''
                            }}
                          </td>
                          <td>
                            {{
                              solicitudEdicionSeleccionada
                                ? solicitudEdicionSeleccionada.oldData.email
                                : ''
                            }}
                          </td>
                          <td>
                            {{
                              solicitudEdicionSeleccionada
                                ? solicitudEdicionSeleccionada.oldData.rol
                                : ''
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="mt-4 mb-4" />
          <div class="row">
            <div class="card">
              <div class="card-body">
                <div class="row mb-4">
                  <div class="col-md-12">
                    <h5>Datos nuevos</h5>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-md-12">
                    <div class="form-sample">
                      <div class="col-lg-12">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="nombre">Nombre</label>
                              <input
                                type="text"
                                id="nombre"
                                class="form-control"
                                placeholder="Nombre"
                                v-model.trim="solicitudEdicionSeleccionada.newData.nombre"
                                disabled
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="email">Email</label>
                              <input
                                type="text"
                                id="email"
                                class="form-control"
                                placeholder="Email"
                                v-model.trim="solicitudEdicionSeleccionada.newData.email"
                                disabled
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="rol">Rol</label>
                              <input
                                type="text"
                                id="rol"
                                class="form-control"
                                placeholder="Rol"
                                v-model.trim="solicitudEdicionSeleccionada.newData.rol"
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-secondary btn-general-off mr-2"
              @click="regresar"
            >
              <i class="ti-arrow-left"></i> Regresar
            </button>
            <button
              type="button"
              class="btn btn-danger btn-general-off mr-2"
              @click="abrirModalRechazo"
            >
              <i class="ti-close"></i> Rechazar
            </button>
            <button
              type="button"
              class="btn btn-success btn-general"
              @click="abrirModalAprobacion"
            >
              <i class="ti-check"></i> Aprobar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Aprobación -->
    <div
      class="modal fade"
      id="modalAprobacion"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalAprobacionLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="modalAprobacionLabel"
            >
              Aprobar Solicitud
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="observacionAprobacion">Observación (Opcional)</label>
              <textarea
                id="observacionAprobacion"
                class="form-control"
                rows="3"
                placeholder="Ingrese alguna observación..."
                v-model.trim="formData.observacion"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-general-off"
              data-dismiss="modal"
            >
              <i class="ti-close"></i> Cancelar
            </button>
            <button
              type="button"
              class="btn btn-success btn-general"
              @click="aprobar"
            >
              <i class="ti-check"></i> Confirmar Aprobación
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Rechazo -->
    <div
      class="modal fade"
      id="modalRechazo"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalRechazoLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="modalRechazoLabel"
            >
              Rechazar Solicitud
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="motivoRechazo">Motivo de Rechazo *</label>
              <textarea
                id="motivoRechazo"
                class="form-control"
                rows="3"
                placeholder="Ingrese el motivo del rechazo..."
                v-model.trim="formData.motivoRechazo"
                :class="{ 'is-invalid': errorRechazo }"
              ></textarea>
              <div
                v-if="errorRechazo"
                class="invalid-feedback"
              >
                El motivo de rechazo es obligatorio
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-general-off"
              data-dismiss="modal"
            >
              <i class="ti-close"></i> Cancelar
            </button>
            <button
              type="button"
              class="btn btn-danger btn-general"
              @click="rechazar"
            >
              <i class="ti-close"></i> Confirmar Rechazo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SolicitudModificacionForm',
  data() {
    return {
      formData: {
        observacion: '',
        motivoRechazo: '',
      },
      error: false,
      errorRechazo: false,
      mensaje: '',
    };
  },
  mounted() {
    if (this.solicitudEdicionSeleccionada) {
      this.formData = { ...this.solicitudEdicionSeleccionada, observacion: '', motivoRechazo: '' };
    }
  },
  methods: {
    loaderSpinner() {
      this.loader = this.$loading.show();
    },
    abrirModalAprobacion() {
      this.formData.observacion = '';
      window.$('#modalAprobacion').modal('show');
    },
    abrirModalRechazo() {
      this.formData.motivoRechazo = '';
      this.errorRechazo = false;
      window.$('#modalRechazo').modal('show');
    },
    regresar() {
      this.$router.go(-1);
    },
    async aprobar() {
      this.loaderSpinner();
      try {
        await this.$store.dispatch('solicitudModificacion/aprobar', this.formData);
        window.$('#modalAprobacion').modal('hide');
        this.loader.hide();
        this.$swal({
          text: 'Solicitud aprobada con éxito',
          icon: 'success',
        }).then(() => {
          this.$router.push({ name: 'SolicitudRegistro' });
        });
      } catch (error) {
        window.$('#modalAprobacion').modal('hide');
        this.loader.hide();
        this.$swal({
          text: 'No se logró aprobar la solicitud',
          icon: 'error',
        });
      }
    },
    async rechazar() {
      if (!this.formData.motivoRechazo || this.formData.motivoRechazo.trim() === '') {
        this.errorRechazo = true;
        return;
      }

      this.errorRechazo = false;
      this.loaderSpinner();
      try {
        await this.$store.dispatch('solicitudModificacion/rechazar', this.formData);
        window.$('#modalRechazo').modal('hide');
        this.loader.hide();
        this.$swal({
          text: 'Solicitud rechazada con éxito',
          icon: 'success',
        }).then(() => {
          this.$router.push({ name: 'SolicitudRegistro' });
        });
      } catch (error) {
        window.$('#modalRechazo').modal('hide');
        this.loader.hide();
        this.$swal({
          text: 'No se logró rechazar la solicitud',
          icon: 'error',
        });
      }
    },
  },
  computed: {
    solicitudEdicionSeleccionada() {
      return this.$store.getters['solicitudModificacion/solicitudEdicionSeleccionada']
        ? this.$store.getters['solicitudModificacion/solicitudEdicionSeleccionada']
        : null;
    },
  },
};
</script>
